import { render, staticRenderFns } from "./tableTagOne.vue?vue&type=template&id=6ad6c50a&scoped=true"
import script from "./tableTagOne.vue?vue&type=script&lang=js"
export * from "./tableTagOne.vue?vue&type=script&lang=js"
import style0 from "./tableTagOne.vue?vue&type=style&index=0&id=6ad6c50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6c50a",
  null
  
)

export default component.exports